import React, { useEffect, useState } from "react";
import { Col, Flex, Form, Input, Row, Table } from "antd";
import { HeaderCell } from "../Dashboard/HeaderCell";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import css from "./Report.module.css";

export const Preview = ({rows, headers, fileName}) => {
  const columns = headers.map(header=>({
	title: <span className={css.headerText}>{header}</span>,
	editable: false,
	dataIndex: header,  
	sorter: false,
	align: "left",

  }));

  return (
	<Flex className={""} vertical>
		<SectionHeader title="Preview" />
		<Table
			components={{
				header: {
					row: HeaderCell,
				},
			}}
			columns={columns}
			dataSource={rows.slice(0, 10)}
			style={{ marginTop: 10 }}
			scroll={{ x: "100%" }}
			pagination={false}
			className={css.previewTable}
		/>
	</Flex>
  );
};
